import log from '@vcclive/log';
import * as React from 'react';
import { Store } from 'redux';
import { connect } from 'react-redux';
import { IMessage, MessageState, RootState, State } from './client-reducer';
import ChatIcon from './ChatIcon';
import ChatWindow, { ChatWindowProps, ChatWindowActions } from './ChatWindow';

const debug = log.getDebug('app');

const tick = 17;
const transitionLength = 200;

interface Props {
    store: Store<RootState>;
}
interface AppState {
    transition: string;
}

class App extends React.Component<ChatWindowProps, AppState> {
    state = {
        transition: '',
    };

    timeoutId: ReturnType<typeof setTimeout> | undefined;

    static getDerivedStateFromProps(props: ChatWindowProps, state: AppState) {
        if (props.transition && state.transition.indexOf(props.transition) === 0) {
            return null;
        }
        return {
            transition: props.transition,
        };
    }

    render() {
        return (
            <div>
                {this.props.showIcon && <ChatIcon {...this.props} onClick={this.open}/>}
                {this.props.showWindow && <ChatWindow {...this.props} transition={this.state.transition}/>}
            </div>
        );
    }

    open = () => {
        this.props.open();
    };

    componentDidUpdate() {
        debug(`transition: ${this.state.transition}`);
        if (this.state.transition) {
            this.timeout(this.startTransition, tick);
        }
    }

    startTransition = () => {
        this.setState(s => ({ transition: `${s.transition} active` }), () => {
            this.timeout(this.endTransition, transitionLength);
        });
    };

    endTransition = () => {
        if (this.state.transition === 'enter active') {
            this.props.opened();
        }
        if (this.state.transition === 'leave active') {
            this.props.closed();
        }
    };

    timeout = (handler: () => void, timeout: number) => {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(handler, timeout);
    };
}

const mapState = ({ root }: RootState) => root;

const mapDispatch = {
    open() {
        return { type: 'open' };
    },
    opened() {
        return { type: 'opened' };
    },
    close() {
        return { type: 'close' };
    },
    closed() {
        return { type: 'closed' };
    },
    selectQueue(id: number) {
        return {
            type: 'selectQueue',
            payload: { id },
        };
    },
    sendMessage(message: IMessage) {
        return {
            type: 'sendMessage',
            payload: message,
        };
    },
    setMessageState(message: IMessage, state: MessageState) {
        return {
            type: 'setMessageState',
            payload: {
                message,
                state,
            },
        };
    },
    startNewSession() {
        return { type: 'startNewSession' };
    },
};

export default connect<State, ChatWindowActions, Props, RootState>(mapState, mapDispatch)(App);
